import { Component,ViewContainerRef  } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from "@angular/http";
import { ElementRef, NgZone, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { } from 'googlemaps';
import { MapsAPILoader } from '@agm/core';
import {} from '@types/googlemaps';
import {server, post_get_post_list, km} from "../services/index.path";
import {PublicationService } from "../nservices/publication.service";
import {MarkerModel } from "../models/marker.model";
import {CommentModel} from "../models/comment.model";
import {LocationModel} from "../models/location.model";
import {CommentService} from "../services/comment.service";
import { FilterService } from '../nservices/map/filter.service';
import { FilterModel } from '../models/filterModel';
import { SharedinfoService } from '../nservices/sharedinfo.service';
import { PublicationModel } from '../nmodels/publication.model';
import { CredentialsService } from '../nservices/login/credentials.service';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { Marker } from '@agm/core/services/google-maps-types';

@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.css']
})
export class MapComponent implements OnInit {

  @ViewChild('search')
  public searchElement:ElementRef;

  //Hidden the maps landmarks default
  public whitoutPoints = [{
      "featureType": "poi",
      "elementType": "labels",
      "stylers": [{
          "visibility": "off"
        }]
      }
    ];

  lat: string | number = 43.2388841;
  lng: string | number = -79.8897273;
  searchControl: FormControl;
  zoom: number = 13;
  publications?:PublicationModel[];
  tempArray:PublicationModel[];
  emptypost:PublicationModel[] = [];
  markers?:MarkerModel[] = [];
  source = server
  locationmodel?:LocationModel;
  temp?:PublicationModel;
  comments?:CommentModel[];
  comment:string = "";

  previous:any;
  filter_event?:any;
  filter_username?:any;
  filter_time?:any;
  filter_time_end?:any;
  filter_date_start?:any;
  filter_date_final?:any;
  filter:FilterModel;
  filterkm:string = "1";
  no_access_field:boolean = false;


  constructor(public http: Http,private mapsAPILoader: MapsAPILoader,private ngZone: NgZone,private _publicationsS:PublicationService,
              private _commentS:CommentService,private _filterS:FilterService,private _sharedInfoS:SharedinfoService,
              private _credentialsS:CredentialsService,public toastr: ToastsManager, vcr: ViewContainerRef) {
    this.toastr.setRootViewContainerRef(vcr);
    this.filter = new FilterModel();
    this._sharedInfoS.subjecttoback.subscribe(param =>{
      if(param == 1){
        console.log("to back recived = "+param);
        this.locationmodel = this._sharedInfoS.getlastLocation();
        if(this.locationmodel){
          console.log("location from service = "+JSON.stringify(this.locationmodel));
          this.lat = Number(this.locationmodel.latitude);
          this.lng = Number(this.locationmodel.longitude);
          console.log('get last search = '+this._sharedInfoS.getLastSearch());

          if(this._sharedInfoS.getLastSearch()=='filter'){
            let filter:FilterModel = this._sharedInfoS.getFilterParams();
            this.setValuesonFilter(filter);
            this._filterS.filtering(filter)
     .subscribe(data =>{
      (<HTMLInputElement>document.getElementById('filter_event')).setAttribute('filter_event','');
       this.getPublicacionSusbcribe(data,10);
     });
          }
          else this.setLocalMarkersDaysBefore(Number(this.locationmodel.latitude),Number(this.locationmodel.longitude));
        }else {
          this.publications = this._sharedInfoS.getPublicationsFiltered();
          let filter:FilterModel = this._sharedInfoS.getFilterParams();
            this.setValuesonFilter(filter);
          this.zoom = 10;
          this.fillMarkers();
          console.log("location from service is null");
        }

      }else{
        console.log("re recibio como toback = "+param);
        this.setCurrentPosition();

      }
    });
    this.prepareBrowserPalces();
    this.temp = new PublicationModel();

  }

  ngOnInit() {

  }


  prepareBrowserPalces(){
    this.searchControl = new FormControl();
    this.mapsAPILoader.load().then(
      ()=>{
        let autocomplete = new google.maps.places.Autocomplete(this.searchElement.nativeElement,{
        });
        autocomplete.addListener("place_changed", ()=>{
          this.ngZone.run(
            ()=>{
              let place: google.maps.places.PlaceResult = autocomplete.getPlace();

              if (place.geometry === undefined || place.geometry === null) {
                  return;
              }
              this.lat = place.geometry.location.lat();
              this.lng = place.geometry.location.lng();
              this.updatelocation(this.lat,this.lng);
              this.setLocalMarkersDaysBefore(this.lat,this.lng);
            }
          )
        })
      }
    );
  }


  markerClicked(infowindow?, idx?:number){
  if (this.previous) {
        this.previous.close();
    }
    this.previous = infowindow;
    if(!this._credentialsS.getCredentials())this.no_access_field = true;
    else this.no_access_field = false;
    this.temp = this.publications[idx];
    this.getComments();
  }

  makeComment(){
    console.log("id del post para comentar: "+this.temp.id);
    this._commentS.storeComment(this.temp.id,this.comment).subscribe(()=>{
      this.getComments();
    })
  }
  /**
   * recibe el indice del arreglo de comentarios
   * @param comment_idx
   */
  deleteComment(comment_idx){
    if(confirm("¿Estas seguro de elimar este comentario?")){
      this._commentS.deleteComment(this.comments[comment_idx].id)
          .subscribe(()=> {
            alert("Listo");
            this.getComments();
          });
    }
  }

  setCurrentPosition() {
      if ("geolocation" in navigator) {
        navigator.geolocation.getCurrentPosition((position) => {
          this.lat = position.coords.latitude;
          this.lng = position.coords.longitude;
          //this.updatelocation(this.lat,this.lng);
          this.setLocalMarkersDaysBefore(this.lat,this.lng);

        });
      } else{
        this.lat = 18.2084564;
        this.lng = -73.8974265;
        this.updatelocation(this.lat,this.lng);
      }

    }


  setLocalMarkersDaysBefore(lat:number,lng:number){
    console.log("setting localmarkersanddaysbefore in = "+lat+" | "+lng);

    this._publicationsS.getPublicationsByLocationAndDays(String(lat),String(lng),km)
    .subscribe(resp => {
      this.getPublicacionSusbcribe(resp,13);
    })
  }

  aplicarfiltros(){
    this.filter.event = (<HTMLInputElement>document.getElementById('filter_event')).value;
    this.filter.username = (<HTMLInputElement>document.getElementById('filter_username')).value;
    this.filter.time = (<HTMLInputElement>document.getElementById('filter_time')).value;
    this.filter.time_end = (<HTMLInputElement>document.getElementById('filter_time_end')).value;
    this.filter.date_start = (<HTMLInputElement>document.getElementById('filter_date_start')).value;
    this.filter.date_final = (<HTMLInputElement>document.getElementById('filter_date_final')).value;
    this.filter.km = this.filterkm;
    console.log(JSON.stringify(this.filter));
    if(this.validateFilterModel(this.filter)){
      this.updatelocation(Number(this.lat),Number(this.lng),'filter',this.filter);
      this._filterS.filtering2(this.filter,String(this.lat),String(this.lng))
     .subscribe(data =>{
       this.getPublicacionSusbcribe(data,10);
     });
    // this._filterS.filtering(this.filter)
    //  .subscribe(data =>{
    //   //(<HTMLInputElement>document.getElementById('filter_event')).setAttribute('filter_event','');
    //    this.getPublicacionSusbcribe(data,10);
    //  });
    }
  }
  private cleanMarkers(){
    for (let i = 0; i < this.markers.length; i++) {
      this.markers.splice(i);

    }
  }
  private fillMarkers(){
    console.log('filling markers');

    this.publications.forEach(post => {
      let mark = new MarkerModel(post.id, Number(post.latitude_event), Number(post.longitude_event), post.title, post.file);
      this.markers.push(mark);
      });
  }

  private getPublicacionSusbcribe(data:any,zoom:number){
    this.publications = data;
      if(this.publications.length>0){
       this.cleanMarkers();
       this.fillMarkers();
       this.zoom = zoom;
       this.publications = this._publicationsS.validatePicture(this.publications);
       this._sharedInfoS.updatePublications(this.publications);
       if(zoom ==10){
         this._sharedInfoS.setPublicationsFiltered(this.publications);
       }
      }else{
        this.publications = [];
        this._sharedInfoS.updatePublications(this.publications);
        this.cleanMarkers();
        this.toastr.info('"Bueno esto es raro, no hay publicaciones por aqui en los ultimos dias porque no publicas algo?"');
        // alert("Bueno esto es raro, no hay publicaciones por aqui en los ultimos dias porque no publicas algo?");
      }
  }
  private getComments(){
    this._commentS.getByPost(this.temp.id)
           .subscribe(resp => {
             this.comments = resp;
             this.comments.reverse();
           })
  }
  cleanFilterFields(){
    (<HTMLInputElement>document.getElementById('filter_event')).value = "";
    (<HTMLInputElement>document.getElementById('filter_username')).value = "";
    (<HTMLInputElement>document.getElementById('filter_time')).value = "";
    (<HTMLInputElement>document.getElementById('filter_time_end')).value = "";
    (<HTMLInputElement>document.getElementById('filter_date_start')).value = "";
    (<HTMLInputElement>document.getElementById('filter_date_final')).value = "";
  }

  updatelocation(lat:number,lng:number,type:string = 'normal',filterparams?:FilterModel){
    console.log("location saved in service values = "+lat+" | "+lng);

    let location:LocationModel = new LocationModel(String(lat),String(lng));
    this._sharedInfoS.setlastLocation(location);
    this._sharedInfoS.setLastSearch("normal");
    if(filterparams)this._sharedInfoS.setFilterParams(filterparams);
  }

  validateFilterModel(filter:FilterModel):boolean{
    if(filter.event=="" && filter.date_start=="" && filter.date_final=="" && filter.time=="" && filter.username==""){
      return false;
    }
    else if(filter.date_start=="" && filter.date_final=="" || filter.date_start!="" && filter.date_final!="")
      return true;
    else {
      alert("Ambos campos e fecha deben de estar completos o vacios");
      return false;
    }
  }

  setValuesonFilter(filter:FilterModel){
    console.log('set values on filter');
    console.log(JSON.stringify(filter));

    if(filter.event!='')(<HTMLInputElement>document.getElementById('filter_event')).value = filter.event;
    if(filter.username!='')(<HTMLInputElement>document.getElementById('filter_username')).value = filter.username;
    if(filter.time!='')(<HTMLInputElement>document.getElementById('filter_time')).value = filter.time;
    if(filter.time_end!='')(<HTMLInputElement>document.getElementById('filter_time_end')).value = filter.time_end;
    if(filter.date_start!='')(<HTMLInputElement>document.getElementById('filter_date_start')).value = filter.date_start;
    if(filter.date_final!='')(<HTMLInputElement>document.getElementById('filter_date_final')).value = filter.date_final;
    if(filter.km!='')this.filterkm = filter.km;
  }
  //this event get coords when green marker is dragged and get local publications
  dragEnd(event){
    this.lat =  event.coords.lat;
    this.lng = event.coords.lng;
    // console.log(event.coords.lat);
    // console.log(event.coords.lng);
    // console.log(this.lat);
    // console.log(this.lng);
    this.setLocalMarkersDaysBefore(Number(this.lat),Number(this.lng));


  }
}



// WEBPACK FOOTER //
// C:/Users/CLAUDIA/Desktop/Timeplacebook2/src/app/map/map.component.ts